import asyncActionType from "../../Utils/reduxActions";

const CARE_WATCH_ACTIONS = {
  LIST: asyncActionType("[VERTEX360]CARE_WATCH_LIST"),
  LIST_CALL: "[VERTEX360]CARE_WATCH_LIST_CALL",

  OVERVIEW: asyncActionType("[VERTEX360]CARE_WATCH_OVERVIEW"),
  OVERVIEW_CALL: "[VERTEX360]CARE_WATCH_OVERVIEW_CALL",

  ACKNOWLEDGE: asyncActionType("[VERTEX360]CARE_WATCH_ACKNOWLEDGE"),
  ACKNOWLEDGE_CALL: "[VERTEX360]CARE_WATCH_ACKNOWLEDGE_CALL",

  SET_RISK: asyncActionType("[VERTEX360]CARE_WATCH_SET_RISK"),
  SET_RISK_CALL: "[VERTEX360]CARE_WATCH_SET_RISK_CALL",

  PROMOTE: asyncActionType("[VERTEX360]CARE_WATCH_PROMOTE"),
  PROMOTE_CALL: "[VERTEX360]CARE_WATCH_PROMOTE_CALL",

  DETAIL: asyncActionType("[VERTEX360]CARE_WATCH_DETAIL"),
  DETAIL_CALL: "[VERTEX360]CARE_WATCH_DETAIL_CALL",

  SET_FILTER: "[VERTEX360]CARE_WATCH_SET_FILTER",
  SET_FILTERS: "[VERTEX360]CARE_WATCH_SET_FILTERS",
  CLEAR_FILTERS: "[VERTEX360]CARE_WATCH_CLEAR_FILTERS",
  SET_PAGE: "[VERTEX360]CARE_WATCH_SET_PAGE",
  SET_PAGE_SIZE: "[VERTEX360]CARE_WATCH_SET_PAGE_SIZE",
  TOGGLE_ROW: "[VERTEX360]CARE_WATCH_TOGGLE_ROW",
  SET_SELECTED: "[VERTEX360]CARE_WATCH_SET_SELECTED",
  TOGGLE_CHECKED: "[VERTEX360]CARE_WATCH_TOGGLE_CHECKED",
  TOGGLE_ALL_PAGE: "[VERTEX360]CARE_WATCH_TOGGLE_ALL_PAGE",
  CLEAR_CHECKED: "[VERTEX360]CARE_WATCH_CLEAR_CHECKED",
  SET_ACTIVE_KPI: "[VERTEX360]CARE_WATCH_SET_ACTIVE_KPI",
  RESET: "[VERTEX360]CARE_WATCH_RESET",
  UPDATED_PUSHER_RECEIVED: "[VERTEX360]CARE_WATCH_UPDATED_PUSHER_RECEIVED",
  RESET_UPDATED_PUSHER: "[VERTEX360]CARE_WATCH_RESET_UPDATED_PUSHER",
};

export const getCareWatchList = {
  pending: { type: CARE_WATCH_ACTIONS.LIST.PENDING },
  success: (data) => ({ type: CARE_WATCH_ACTIONS.LIST.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.LIST.ERROR, error }),
};

export const getCareWatchListRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.LIST_CALL,
  payload,
});

/** KPI tile counts, computed server-side from the same filters as the list. */
export const getCareWatchOverview = {
  pending: { type: CARE_WATCH_ACTIONS.OVERVIEW.PENDING },
  success: (data) => ({ type: CARE_WATCH_ACTIONS.OVERVIEW.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.OVERVIEW.ERROR, error }),
};

export const getCareWatchOverviewRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.OVERVIEW_CALL,
  payload,
});

export const acknowledgeCareWatchSignals = {
  pending: { type: CARE_WATCH_ACTIONS.ACKNOWLEDGE.PENDING },
  success: (data) => ({ type: CARE_WATCH_ACTIONS.ACKNOWLEDGE.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.ACKNOWLEDGE.ERROR, error }),
};

export const acknowledgeCareWatchSignalsRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.ACKNOWLEDGE_CALL,
  payload,
});

export const setCareWatchRisk = {
  pending: (id) => ({
    type: CARE_WATCH_ACTIONS.SET_RISK.PENDING,
    id,
  }),
  success: (data) => ({ type: CARE_WATCH_ACTIONS.SET_RISK.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.SET_RISK.ERROR, error }),
};

export const setCareWatchRiskRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.SET_RISK_CALL,
  payload,
});

export const promoteCareWatchSignal = {
  pending: { type: CARE_WATCH_ACTIONS.PROMOTE.PENDING },
  success: (data) => ({ type: CARE_WATCH_ACTIONS.PROMOTE.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.PROMOTE.ERROR, error }),
};

export const promoteCareWatchSignalRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.PROMOTE_CALL,
  payload,
});

/** On-demand detail for a single signal (full payload). */
export const getCareWatchDetail = {
  pending: { type: CARE_WATCH_ACTIONS.DETAIL.PENDING },
  success: (data) => ({ type: CARE_WATCH_ACTIONS.DETAIL.SUCCESS, data }),
  error: (error) => ({ type: CARE_WATCH_ACTIONS.DETAIL.ERROR, error }),
};

export const getCareWatchDetailRequest = (payload) => ({
  type: CARE_WATCH_ACTIONS.DETAIL_CALL,
  payload,
});

export const setCareWatchFilter = (key, value) => ({
  type: CARE_WATCH_ACTIONS.SET_FILTER,
  payload: { key, value },
});

/** Several filter keys in one update, so a date range refetches once. */
export const setCareWatchFilters = (updates) => ({
  type: CARE_WATCH_ACTIONS.SET_FILTERS,
  payload: updates || {},
});

export const clearCareWatchFilters = (payload = {}) => ({
  type: CARE_WATCH_ACTIONS.CLEAR_FILTERS,
  payload,
});

export const setCareWatchPage = (page) => ({
  type: CARE_WATCH_ACTIONS.SET_PAGE,
  payload: page,
});

export const setCareWatchPageSize = (pageSize) => ({
  type: CARE_WATCH_ACTIONS.SET_PAGE_SIZE,
  payload: pageSize,
});

export const toggleCareWatchRow = (id) => ({
  type: CARE_WATCH_ACTIONS.TOGGLE_ROW,
  payload: id,
});

export const setCareWatchSelected = (id) => ({
  type: CARE_WATCH_ACTIONS.SET_SELECTED,
  payload: id,
});

export const toggleCareWatchChecked = (id) => ({
  type: CARE_WATCH_ACTIONS.TOGGLE_CHECKED,
  payload: id,
});

export const toggleCareWatchAllPage = (pageIds) => ({
  type: CARE_WATCH_ACTIONS.TOGGLE_ALL_PAGE,
  payload: pageIds,
});

export const clearCareWatchChecked = () => ({
  type: CARE_WATCH_ACTIONS.CLEAR_CHECKED,
});

export const setCareWatchActiveKpi = (key) => ({
  type: CARE_WATCH_ACTIONS.SET_ACTIVE_KPI,
  payload: key,
});

export const resetCareWatch = () => ({
  type: CARE_WATCH_ACTIONS.RESET,
});

export const careWatchUpdatedPusherReceived = (data) => ({
  type: CARE_WATCH_ACTIONS.UPDATED_PUSHER_RECEIVED,
  data,
});

export const resetCareWatchUpdatedPusher = () => ({
  type: CARE_WATCH_ACTIONS.RESET_UPDATED_PUSHER,
});

export default CARE_WATCH_ACTIONS;
